import React, { useEffect, useState } from "react";
import {
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBInput,
    MDBIcon,
    MDBSelect,
    MDBSpinner,
    MDBBtn,
    MDBAlert
} from "mdb-react-ui-kit";

import {
    DndContext,
    closestCenter,
    useSensors,
    useSensor,
    PointerSensor
} from "@dnd-kit/core";
import {
    SortableContext,
    verticalListSortingStrategy,
    arrayMove
} from "@dnd-kit/sortable";

import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { DragAndDrop } from "../../components/images/index.js";
import { SortableItem } from "./SortableItem.js";
import provisioningHelper from "../../components/topviews/phonesanddevices/provisioning_helper.js";
import { useForm, useFieldArray, FormProvider, Controller } from "react-hook-form";
import { getdevicedatainfo, saveAutoDectDeviceSettings, saveDectDeviceButtonsData } from "../../apiclients/streamsapi_bridge.js";
import SaveChanges from "../../components/topviews/saveCancel.js";
import { t } from "i18next";
const YealinkDectButtons = (props) => {
    const deviceData = props.deviceInfo;
    const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 8 } }));
    const [rows, setRows] = useState();
    const [buttonTypes, setButtonTypes] = useState([]);
    const [pbxUsersList, setPBXUserList] = useState([]);
    const [telephonyUsersList, setTelephonyUsersList] = useState([]);
    const [linesDBData, setLinesDBData] = useState([]);
    const [linesDBMap, setLinesDBMap] = useState(new Map());
    const [updatesuccessMessage, setUpdateSuccessMessage] = useState("");
    const [updateFailureMessage, setUpdateFailureMessage] = useState(false);
    const [removedUsersList,setRemovedList] = useState([]);
   

  const [loading, setLoading] = useState(false);


    const myForm = useForm({ defaultValues: { dataList: [] } });

    const {
        reset,
        control,
        formState: { isDirty,errors,dirtyFields },
        getValues,
        register,
        setError,clearErrors,setValue
    } = myForm;

    const { fields, remove, move,update} = useFieldArray({
        control,
        name: "dataList",
    });

    async function fetchData() {
        setLoading(true)
        let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        const [accountsData] = await Promise.all([
            provisioningHelper.getAccountUsersList(siteid),
        ]);
        const [linesList, linesMap] = await provisioningHelper.getLinesInfo(siteid, deviceData);
        const [telephonyUsersList, pbxUsersList] = accountsData;
        console.log(telephonyUsersList)

        setButtonTypes([
            { text: "Empty", value: 0 },
            { text: "Line", value: 1 },
        ]);
        setTelephonyUsersList(telephonyUsersList);
        setPBXUserList(pbxUsersList);
        console.log(linesList)
      
        const enrichedLines = await Promise.all(
            linesList.map(async (element, index) => {
              if (element.user_value_name === "") return element;
              element.user_or_value = parseInt(element.user_or_value);
              element.isDisabled = true
              element.isOld =true

              const useDetails = telephonyUsersList.find(
                (user) => user.user_pbxid == parseInt(element.user_or_value)
              );
          
              if (useDetails) {
                const responseData = await getPhoneDesignationsforAgent(useDetails.agentid);
                const defualtDesignationArray = [{ text: "IP Phone 1", value: 1 },{ text: "IP Phone 2", value: 2 }];
                let designationArray = responseData.deviceInfo
                  .filter((d) => d.model === "-")
                  .map((d) => ({ text: d.designation, value: d.value }));
                if (index === 0 || designationArray.length === 0) {
                        element.designation_array = [defualtDesignationArray[element.designation - 1]];
                        return element
                }else if(designationArray.length === 1){
                    element.designation_array = [...designationArray,defualtDesignationArray[element.designation - 1]];
                    return element
                }
                else{
                    element.designation_array = designationArray;
                }
                
                // element.agent_id = useDetails.agentid
              }
          
              return element;
            })
          );
          
          setLinesDBData(enrichedLines);
          setLinesDBMap(linesMap);
          setTimeout(()=>{
            setLoading(false)
          },1000)
          
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (linesDBData.length > 0) {
            reset({ dataList: linesDBData });
        }
    }, [linesDBData, reset]);

    useEffect(() => {
        props.setEdited(isDirty);
    }, [isDirty]);


    const onSubmit = async function (data) {
        try {
            console.dir(dirtyFields);
            console.log("handleSubmit method is called " + data?.dataList.length);
            console.log("Lines Info :::"+JSON.stringify(data.dataList))
            let updatedUsersList = [];
            let filteredData = [];
            data.dataList.forEach((item) => {
                if (item.user_or_value !== "") {
                    if (Object.hasOwn(item, "updated_user")) {
                        updatedUsersList.push(item);
                    } else {
                        filteredData.push(item);
                    }
                }
            });
            console.log("Lines Info without Empty Lines :::"+data)
            if (dirtyFields?.dataList && dirtyFields.dataList.length > 0) {
              setLoading(true);
              const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
              let jo = {
                linesInfo:filteredData,
                updatedLines:updatedUsersList,
                removedLines:removedUsersList,
                macaddress:deviceData.macaddress,
                device_uuid:deviceData.device_uuid
              };
              console.log(jo)
              const response = await saveDectDeviceButtonsData(
                siteid,
                jo,
              );

              if (response.status == 200) {
                await fetchData();
                setRemovedList([]);
                setLoading(false);
                setUpdateSuccessMessage("Buttons successfully updated. Please reboot the device.");
                setTimeout(() => {
                  setUpdateSuccessMessage(""); // Clear the success message 
                }, 5000);
              }else{     
                setUpdateFailureMessage(true);
                setTimeout(() => {
                  setUpdateFailureMessage(false); // Clear the failure message 
                  setLoading(false);
                }, 3000);
                setRemovedList([]);
                // reset({ dataList: linesDBData });
                fetchData();
              }
            }
        } catch (error) {
            console.log(error)
        }

    }

   /* const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over) return;
        // const newLine = getValues(`dataList.${active.data.current.sortable.index}`);
        // const oldLine = getValues(`dataList.${over.data.current.sortable.index}`);
        // update(newLine.index,{
        //     ...newLine,
        //     button_no:oldLine.button_no,
        //     index:oldLine.index
        // })
        // update(oldLine.index,{
        //     ...oldLine,
        //     button_no:newLine.button_no,
        //     index:newLine.index
        // })
        if (active.id !== over.id) {
            const oldIndex = fields.findIndex((item) => item.id === active.id);
            const newIndex = fields.findIndex((item) => item.id === over.id);
            move(oldIndex, newIndex);
        }
    };*/

    useEffect(() => {
        if (linesDBData.length > 0) {
            // Ensure every item has user_value_name
            const formattedData = linesDBData.map((item) => ({
                ...item,
                user_value_name: item.user_value_name || "",
            }));
            reset({ dataList: formattedData });
        }
    }, [linesDBData, reset]);

    const handleButtonChange=async(item,index)=>{
        if (!item) return;
        if (!item.value || item.value === getValues(`dataList.${index}.user_or_value`)) {
            return;
        }
        console.log("handleUserChange : " + item.value);
        let dataListValues = getValues("dataList");
        let userExists = dataListValues.some((user)=>user.user_or_value.toString() === item.value.toString())
        console.log(userExists)
        if (userExists) {
          setError(`dataList.${index}.user_or_value`, {
            message: "User Already Exists",
          });
          return;
        }
        clearErrors(`dataList.${index}.user_or_value`);
    
        const [selectedUser] = pbxUsersList.filter(
          (user) => user.value == item.value
        );
        const useDetails = await telephonyUsersList.find((user)=>user.user_pbxid === item.value);
        console.log(useDetails)
        console.log(selectedUser)
        if (selectedUser && useDetails) {
            setLoading(true)
          const responseData = await getPhoneDesignationsforAgent(useDetails.agentid)
          let designationArray = responseData.deviceInfo.filter((d)=>(d.model === "-"))
          designationArray = designationArray.map((d)=>({text:d.designation,value:d.value}))
          if(designationArray.length === 0){
            designationArray=[];
            setError(`dataList.${index}.user_or_value`, {
                message: "This user is already associated with two devices.",
              });
              setLoading(false)
              return;
          }
          console.log(designationArray)
          console.log(responseData)
          var fieldObj = getValues(`dataList.${index}`);
          var jo = {
            ...fieldObj,
            user_or_value: selectedUser.value,
            user_value_name: selectedUser.text,
            label: selectedUser.text.split(":")[1].trim(),
            designation_array :designationArray,
            agent_id :useDetails.agentid,
            designation :designationArray[0].value
          };
        //   console.log("updating Jo to : " + JSON.stringify(jo));
        //   if (newLabel && newLabel.trim() !== "") {
        //     clearErrors(`dataList.${props.index}.label`);
        //   }
          update(index, jo);
          setLoading(false)
        }

    }

    const getPhoneDesignationsforAgent = async (agent) => {
        console.log("Request came to getPhoneDesignationsforAgent :");
        try {
          if (agent == "") {
            return;
          }
          let params = { agentid: agent };
          let deviceApiResponse = await getdevicedatainfo(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            params
          );
          return deviceApiResponse.json()
        }catch(e){
            console.log(e)
        }
    }

    const handleDesignationChange =(item,index)=>{
        if(!item) return
        var fieldObj = getValues(`dataList.${index}`);
        if(item.value === fieldObj.designation) return
        console.log("handleDesignationChange : " + item.value);
        const useDetails = telephonyUsersList.find((user)=>user.user_pbxid === fieldObj.user_or_value);
        fieldObj.agent_id = useDetails?.agentid ?? ""

        setValue(`dataList.${index}.designation`, item.value, {
            shouldDirty: true,
          });
          if(Object.hasOwn(fieldObj,"isOld") && fieldObj?.isOld === true){
            setValue(`dataList.${index}.updated_user`, true, {
                shouldDirty: true,
              });
        }
    }

    const handlLableChange =(value,index)=>{
        if(!value) return
        var fieldObj = getValues(`dataList.${index}`);
        console.log(fieldObj)
        const useDetails = telephonyUsersList.find((user)=>user.user_pbxid === fieldObj.user_or_value);
        fieldObj.agent_id = useDetails?.agentid ?? ""
        // if(value === fieldObj.label) return
        console.log("handlLableChange : " + value);
        setValue(`dataList.${index}.label`, value, {
            shouldDirty: true,
          });
          if(Object.hasOwn(fieldObj,"isOld") && fieldObj?.isOld === true){
            setValue(`dataList.${index}.updated_user`, true, {
                shouldDirty: true,
              });
        }
    }

    const handleButtonTypeChange =(item,index)=>{
        if(!item) return
        var fieldObj = getValues(`dataList.${index}`);
        if(item.value === fieldObj.button_type) return
        console.log("handleButtonTypeChange : " + item.value);
       
        var jo = {
            ...fieldObj,
            button_type : item.value
          };
        update(index, jo);
    }

  

    const onCloseChanges = () => {
        console.log(
          "On Close changes Called :::::::reset datalist" +
          JSON.stringify(linesDBData)
        );
        fetchData()
        // reset({ dataList: linesDBData });
        clearErrors("dataList")
        // setCancelChanges(!cancelChanges);
        // setBlfConfirm(false)
      };

      const removeLine =async(index)=>{
        var fieldObj = getValues(`dataList.${index}`);
        console.log(fieldObj)
        const useDetails = await telephonyUsersList.find((user)=>user.user_pbxid === fieldObj.user_or_value);
        fieldObj.agent_id = useDetails?.agentid ?? ""
        setRemovedList([...removedUsersList,fieldObj]);
        update(index,{
            ...fieldObj,
            button_type:0,
            user_or_value:"",
            user_value_name:"",
            label:"",
            designation:"",
            agent_id:"",
            designation_array:[],
            isDisabled:false,
            isOld:false
        })
        clearErrors(`dataList.${index}`);
      }


    return (
        <>
        <FormProvider {...myForm}>
            <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                //   onDragEnd={handleDragEnd}
                modifiers={[restrictToVerticalAxis]}
            >
                {/* <SortableContext items={fields.map((row) => row.id)} strategy={verticalListSortingStrategy}> */}

                    <MDBTable hover>
                        <MDBTableHead>
                            <tr>
                                <th>Buttons</th>
                                <th>Feature</th>
                                <th>User</th>
                                <th>Label</th>
                                <th>Designation</th>
                                <th className="text-center">Remove</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {fields.map((row, index) => (

                                <SortableItem key={row.id} id={row.id}>

                                    <tr>
                                        <td className="fw-bold">
                                            {/* <img src={DragAndDrop} alt="" width={20} /> */}
                                            {index + 1}
                                        </td>
                                        <td>
                                            <div>
                                               
                                                <Controller
                                                name={`dataList.${index}.button_type`}
                                                control={control}
                                                shouldUnregister="true"
                                                defaultValue={row?.button_type}
                                                rules={{}}
                                                render={({
                                                    field: {value},
                                                }) => (

                                                    <MDBSelect
                                                        onChange={(item) => handleButtonTypeChange(item,index)}
                                                        data={buttonTypes}
                                                        value={value}
                                                    // className="w-200px"
                                                    disabled={index === 0 || row?.isDisabled}
                                                    />
                                                )}
                                            />
                                            </div>
                                        </td>
                                        <td>
                                            <Controller
                                                name={`dataList.${index}.user_or_value`}
                                                control={control}
                                                shouldUnregister="true"
                                                defaultValue={row?.user_or_value}
                                                rules={{}}
                                                render={({
                                                    field: {value},
                                                }) => (

                                                    <MDBSelect
                                                        onChange={(item) => handleButtonChange(item,index)}
                                                        data={pbxUsersList}
                                                        value={value}
                                                        search
                                                    // className="w-200px"
                                                    disabled={index === 0 || row?.isDisabled}                                                    />
                                                )}
                                            />
                                            {errors?.dataList &&
                                                errors.dataList[index]?.user_or_value && (
                                                    <p className="text-danger w-250px text-small">
                                                        {
                                                            errors.dataList[index].user_or_value
                                                                ?.message
                                                        }
                                                    </p>
                                                )}
                                        </td>
                                        <td>
                                            {/* <MDBInput size="sm" value={row.label} /> */}
                                            <input
                                                type="text"
                                                className="selectname-small bg-light"
                                                {...register(`dataList.${index}.label`, {
                                                })}
                                                onChange={(e) => handlLableChange(e.target.value,index)}
                                                // disabled ={index === 0 || row?.isDisabled}
                                                />
                                        </td>
                                        <td>
                                            <div>
                                               
                                                 <Controller
                                                name={`dataList.${index}.designation`}
                                                control={control}
                                                shouldUnregister="true"
                                                defaultValue={row?.designation}
                                                rules={{}}
                                                render={({
                                                    field: {value},
                                                }) => (

                                                    <MDBSelect
                                                        onChange={(item) => handleDesignationChange(item,index)}
                                                        data={getValues(`dataList.${index}.designation_array`) ?? []}
                                                        value={value}
                                                    // className="w-200px"
                                                    disabled={index === 0 || row?.isDisabled}
                                                    />
                                                )}
                                            />

                                            </div>
                                        </td>
                                        <td className="text-center">
                                           {index > 0 &&  <MDBIcon fas icon="times" className="cursor-pointer" color="primary" onClick={()=>removeLine(index)} />}
                                        </td>
                                    </tr>
                                </SortableItem>

                            ))}
                        </MDBTableBody>
                    </MDBTable>
                {/* </SortableContext> */}
            </DndContext>

        </FormProvider>
        
            {isDirty && (
                <SaveChanges
                    onClose={onCloseChanges}
                    onSave={(e) => {
                        e.preventDefault();
                        // if (Object.keys(errors).length === 0) { // Check if there are no validation errors
                            myForm.handleSubmit(onSubmit)();
                        // }
                    }}
                    isDisabled={Object.keys(errors).length > 0} // Pass disable state as prop
                />
            )}

            {loading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner
                                size="sm"
                                role="status"
                                tag="span"
                                className="me-2"
                            />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}

            {updatesuccessMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={10000}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{updatesuccessMessage}</span>
                </MDBAlert>
            )}

            {updateFailureMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={100000}
                >
                    {t("Provisioning_Error_Aleart")}
                </MDBAlert>
            )}

        </>

        
    );
};

export default YealinkDectButtons;
